import axios from '../../axios'

// 新增省份文理科信息
export const addProvinceAos = (data) => {
    return axios({
        url: '/api/data/wish/aos',
        method: 'POST',
        data
    })
}

// 获取省份文理科详情
export const getProvinceAosInfo = (data) => {
    return axios({
        url: '/api/data/wish/aos/info',
        method: 'GET',
        data
    })
}

// 修改省份文理科信息
export const editProvinceAos = (data) => {
    return axios({
        url: '/api/data/wish/aos',
        method: 'PUT',
        data
    })
}

// 删除省份文理科信息
export const deleteProvinceAos = (data) => {
    return axios({
        url: '/api/data/wish/aos',
        method: 'DELETE',
        data
    })
}

// 根据综合信息搜索省份文理科列表
export const searchProvinceAosList = (data) => {
    return axios({
        url: '/api/data/wish/aos',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/provinceaos.js